/**
 * Identity label keys shared by form pre-fill (writing a viewer's identity in) and CTA step contact
 * extraction (reading a respondent's identity out), so both accept exactly the same name labels.
 * Matching is exact on the normalized label, so qualified labels ("company name", "last name of
 * your manager") never match. Dependency-free on purpose: both callers are imported widely.
 */

/**
 * Normalizes a label for fuzzy matching: lowercase, strip non-alphanumerics.
 * @param label - A form field label
 * @returns The normalized key
 */
export function normalizeLabel(label: string): string {
  return label.toLowerCase().replace(/[^a-z0-9]/g, "");
}

/** Normalized labels that hold a first name. */
export const FIRST_NAME_KEYS: ReadonlySet<string> = new Set(["firstname", "first", "givenname"]);

/** Normalized labels that hold a last name. */
export const LAST_NAME_KEYS: ReadonlySet<string> = new Set(["lastname", "last", "surname", "familyname"]);

/** Normalized labels that hold a full name (strict, so "company name" never matches). */
export const FULL_NAME_KEYS: ReadonlySet<string> = new Set(["name", "fullname", "yourname"]);
